import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _EcommerceIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.916504 2.91699C0.916504 2.36471 1.36422 1.91699 1.9165 1.91699H5.58317C6.0598 1.91699 6.47018 2.25338 6.56372 2.72074L7.32021 6.50033H22.0832C22.3812 6.50033 22.6637 6.63325 22.8537 6.86288C23.0436 7.09251 23.1213 7.3949 23.0655 7.68765L21.5974 15.386C21.4678 16.0382 21.113 16.6241 20.595 17.0411C20.0798 17.4558 19.4357 17.6772 18.7746 17.667H9.88174C9.22061 17.6772 8.57659 17.4558 8.06135 17.0411C7.54359 16.6243 7.18885 16.0387 7.05917 15.3868L5.52829 7.73813C5.52177 7.71143 5.51633 7.68432 5.51201 7.65683L4.76349 3.91699H1.9165C1.36422 3.91699 0.916504 3.46928 0.916504 2.91699ZM7.7205 8.50033L9.02068 14.9963C9.05878 15.1882 9.16314 15.3605 9.31549 15.4831C9.46784 15.6058 9.65847 15.6709 9.85401 15.6672L9.87317 15.667H18.7832L18.8023 15.6672C18.9979 15.6709 19.1885 15.6058 19.3409 15.4831C19.4924 15.3612 19.5964 15.19 19.635 14.9995L20.8744 8.50033H7.7205ZM7.3335 21.3335C7.3335 20.2289 8.22893 19.3335 9.3335 19.3335C10.4381 19.3335 11.3335 20.2289 11.3335 21.3335C11.3335 22.4381 10.4381 23.3335 9.3335 23.3335C8.22893 23.3335 7.3335 22.4381 7.3335 21.3335ZM17.4165 21.3335C17.4165 20.2289 18.3119 19.3335 19.4165 19.3335C20.5211 19.3335 21.4165 20.2289 21.4165 21.3335C21.4165 22.4381 20.5211 23.3335 19.4165 23.3335C18.3119 23.3335 17.4165 22.4381 17.4165 21.3335Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const EcommerceIcon = assignWithoutSideEffects(_EcommerceIcon, {
  componentId: 'EcommerceIcon',
});

export default EcommerceIcon;
